import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {FITHGameConfig} from "../FITHGameConfig";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";

export class FITHLogoView extends BaseView {
    private _logo: PIXI.Sprite;
    private _logoAnimation: TimelineSprite;

    public playLogoAnimation(): void {
        if (this._logo.visible) {
            this._logoAnimation.getAnimationAutoShowHide(true, true);
        }
    }

    /**
     * @inheritDoc
     */
    protected initAnimations() {
        super.initAnimations && super.initAnimations();
        StageManager.getLayer(FITHGameConfig.instance.LAYERS.LOGO.name).addChild(this);

        this.createLogo();
        this.createLogoIdleAnimation();
    }

    protected onResize(resizeData: IResizeData) {
        super.onResize && super.onResize(resizeData);

        if (NolimitApplication.isLandscape) {
            this._logo.scale.set(0.7);
            this._logoAnimation.scale.set(1.4);
            this._logo.position.set(-120, 75);
            this._logoAnimation.position.set(-120, 75);

            // Calculate logo space to the left
            const leftSpace: number = (resizeData.width - 720) / 2,
                logoWidth: number = this._logo.width,
                isVisible: boolean = (leftSpace + logoWidth / 2) > logoWidth;
            this._logo.visible = isVisible;

            // #330
            if (!isVisible && this._logoAnimation.visible) {
                this._logoAnimation.hide();
            }
        } else {
            this._logo.scale.set(1);
            this._logoAnimation.scale.set(2);
            this._logo.position.set(360, -50);
            this._logoAnimation.position.set(360, -50);
            this._logo.visible = true;
        }
    }

    /**
     * @description To create the logo.
     */
    private createLogo(): void {
        this._logo = new PIXI.Sprite(ImgLoader.getImgTexture("logo"));
        this._logo.anchor.set(0.5);
        this.addChild(this._logo);
    }

    private createLogoIdleAnimation(): void {
        this._logoAnimation = new TimelineSprite(GameResources.getTextures("logoIdle"));
        this._logoAnimation.hide();
        this._logoAnimation.anchor.set(0.5);
        this._logoAnimation.blendMode = PIXI.BLEND_MODES.ADD;
        this.addChild(this._logoAnimation);
    }
}